import { useOrderDetailContext } from '@/context/OrderDetail/OrderDetailContext';
import { Dialog } from '@mui/material';
import { OrderHistory } from '../OrderHistory';

export function OrderHistoryDialog() {
  const orderDetailContext = useOrderDetailContext();

  const handleClose = () => {
    orderDetailContext.setShowHistoryDialog?.(false);
  };

  return (
    <Dialog open={!!orderDetailContext.showHistoryDialog} onClose={handleClose}>
      <OrderHistory />
    </Dialog>
  );
}
